// Central content + real photography for the fundraiser (English)

const A = "https://customer-assets-eiarnc6j.emergentagent.net/job_family-church-fund/artifacts";

export const IMAGES = {
  disasterSite: `${A}/ibq54xgw_WhatsApp%20Image%202026-07-14%20at%2014.59.03.jpeg`, // volunteers serving at the site
  heroBarrio: `${A}/l5j6vg90_WhatsApp%20Image%202026-07-13%20at%2012.29.03%20%281%29.jpeg`, // hillside + supplies
  bagsOnTable: `${A}/xxo38ub0_WhatsApp%20Image%202026-07-13%20at%2012.29.03%20%282%29.jpeg`, // packed relief bags
  suppliesTable: `${A}/11wu6l66_WhatsApp%20Image%202026-07-13%20at%2012.29.03.jpeg`, // toilet paper + water
  groceryCart: `${A}/olqzg0fm_WhatsApp%20Image%202026-07-13%20at%2012.29.03%20%284%29.jpeg`, // shopping for supplies
  mattressesWomen: `${A}/fjj9jwd9_WhatsApp%20Image%202026-07-13%20at%2012.29.03%20%283%29.jpeg`, // two women + mattresses
  waterTanks: `${A}/e8phab1z_WhatsApp%20Image%202026-07-14%20at%2014.59.03%20%283%29.webp`, // clean water tanks
  blueMattress: `${A}/r8vflh51_WhatsApp%20Image%202026-07-14%20at%2014.59.03%20%282%29.jpeg`, // mattress by van
  mealsCarry: `${A}/w5zm54jb_WhatsApp%20Image%202026-07-14%20at%2014.59.03%20%281%29.jpeg`, // carrying hot meals
  mealsCar: `${A}/vrnpsqk1_WhatsApp%20Image%202026-07-13%20at%2012.29.04.jpeg`, // meals + water in car
  mealsPacking: `${A}/1wnj4mqq_WhatsApp%20Image%202026-07-13%20at%2012.29.04%20%281%29.jpeg`, // packing meals
};

export const HERO = {
  overline: "A personal fundraiser · by Maria-Katharina Richters",
  lines: ["For a family", "actively aiding", "Venezuela after", "the earthquakes."],
  body:
    "After the earthquakes devastated Venezuela, one family refused to stand by. David and Reina, my direct contacts here in Spain, are the link to their family in Venezuela, who are helping people in their hometown with food, water, and support to rebuild. I'm Maria-Katharina, and I built this page to help them raise more.",
};

export const CHAPTERS = [
  {
    n: "01",
    title: "What happened",
    body:
      "Two near-simultaneous earthquakes hit the coastal region of La Guaira and Caracas. More than 200 buildings collapsed. Reports describe thousands of deaths and tens of thousands of injuries, with many families left without homes, and so far little institutional support.",
    image: IMAGES.disasterSite,
    tag: "La Guaira & Caracas",
  },
  {
    n: "02",
    title: "What the family is doing",
    body:
      "David and Reina's family in Venezuela, in their hometown just outside the worst-hit area, began helping as soon as they could. Together with their church, they prepare and hand out meals, water and supplies, and are helping people begin to rebuild. David and Reina send photos and videos of the work almost every day.",
    image: IMAGES.mealsCarry,
    tag: "David's family & their church",
  },
  {
    n: "03",
    title: "Where your support goes",
    body:
      "Every contribution buys food, water, and the supplies our field kitchen needs to keep running. There is nothing to dress up; the money becomes meals, delivered by hand, at the site.",
    image: IMAGES.groceryCart,
    tag: "Directly to supplies",
  },
];

export const GALLERY = [
  {
    src: IMAGES.groceryCart,
    caption:
      "Buenas tardes. Preparamos unas bolsas para un sector donde hay 150 damnificados en Las Minas de Baruta.",
  },
  { src: IMAGES.suppliesTable, caption: "Supplies gathered for the community" },
  { src: IMAGES.waterTanks, caption: "Loading water and supplies" },
  { src: IMAGES.bagsOnTable, caption: "Food and essentials for the families" },
  { src: IMAGES.mealsCar, caption: "Meals and water, ready for delivery" },
  { src: IMAGES.mealsPacking, caption: "Preparing meals, one by one" },
];

// YouTube videos from David and Reina of the work in Venezuela.
export const VIDEOS = {
  overline: "From Venezuela",
  heading: "See it for yourself",
  intro:
    "Short videos David and Reina have shared of the family and their church at work, buying and handing out food, water and supplies.",
  featured: { id: "2NO3nz_djcU" },
  shorts: [{ id: "BfYe8uzb0Z4" }, { id: "GKKkhE5KfYI" }],
};

export const IMPACT = [
  { value: "4,734", label: "lives lost" },
  { value: "16,740", label: "people injured" },
  { value: "17,907", label: "homes lost" },
];

export const MARQUEE_ITEMS = [
  "La Guaira",
  "Caracas",
  "Humanitarian relief",
  "Volunteer aid",
];

// Placeholder: exact allocation to be confirmed with the organizers.
export const ALLOCATIONS = [
  {
    title: "Meals & food",
    note: "Prepared and served daily to rescue teams and to families who lost their homes.",
  },
  {
    title: "Clean drinking water",
    note: "Bottled and stored water carried to the field where it is needed most.",
  },
  {
    title: "Field kitchen & supplies",
    note: "Gas, containers and equipment that keep the kitchen running each day.",
  },
  {
    title: "Transport & logistics",
    note: "Fuel and vehicles to reach the affected areas and deliver by hand.",
  },
];

export const TRUST = {
  overline: "Trust & transparency",
  heading: "How your donation reaches the people",
  flow:
    "Donations are passed to David and Reina, my direct contacts here in Spain, who send them to their family in Venezuela. Working with the church Iglesia Cristiana Ríos de Agua Viva (Pastor Ángel Aner González), their family buys and delivers the aid in their hometown. Everyone who contributes can receive a justificante (proof of transfer).",
  points: [
    {
      title: "100% goes to aid",
      note: "Every donation is spent on food, clean water and supplies. Nothing is taken out.",
    },
    {
      title: "Proof of transfer",
      note: "Ask for a justificante and we will share the transfer confirmation for your donation.",
    },
    {
      title: "Receipts & photos",
      note: "We keep receipts and photos of what we buy, available to any donor on request.",
    },
    {
      title: "Video updates",
      note: "We are adding short videos from the people involved, so you can see where your help goes.",
    },
  ],
};


export const CREATOR = {
  overline: "Who started this",
  heading: "A note from Maria",
  paragraphs: [
    "I'm Maria-Katharina Richters, originally from Hamburg, Germany, and now living in Jávea, Spain. I'm not an organization; I'm simply someone who wanted to help, and you're welcome to look me up.",
    "David and his wife, Reina Yohana Isaza Montoya, are my direct contacts here in Spain, and I trust them. David is from Venezuela; his mother, Milagros, is in Ireland. When the earthquakes hit, their family back in Venezuela, in their hometown just outside the worst-hit area, began doing everything they could for their neighbors: food, water, and support to rebuild. David and Reina send me photos and videos of it, almost every day.",
    "I was so moved that I wanted to do more than donate, so I built this page to help them raise more. This is a personal fundraiser for their community in Venezuela, through the church Iglesia Cristiana Ríos de Agua Viva, whose pastor is Ángel Aner González.",
    "David's mother, Milagros, has known him for 40 years. She trusts him completely to make sure every contribution is used for the right purposes. There is no big organization behind this, only people who care. For full transparency, everyone who contributes can receive a justificante (proof) of the funds raised.",
    "Thank you for reading, and for anything you can give.",
  ],
  signoff: "With thanks, Maria-Katharina Richters, Jávea, Spain",
};


// Bank transfer details: edit these values once confirmed.
// Any field left as "To be added" will show as a placeholder to donors.
export const BANK = {
  accountHolder: "Reina Yohana Isaza Montoya",
  bankName: "BBVA",
  iban: "ES02 0182 5645 1502 0164 8852",
  bic: "BBVAESMM",
  reference: "Venezuela Relief + your name",
  note: "This account belongs to Reina Yohana Isaza Montoya (David's wife), who sends the funds on to their family in Venezuela.",
  paypalLink: "", // e.g. https://paypal.me/... leave empty until available
};

// WhatsApp contacts for donor questions and to request a justificante.
export const CONTACTS = [
  { name: "Maria-Katharina (fundraiser)", phone: "+49 175 8412853", wa: "491758412853" },
  { name: "Milagros (David's mother)", phone: "+353 83 873 7026", wa: "353838737026" },
  { name: "Reina Yohana Isaza Montoya", phone: "+34 643 07 00 98", wa: "34643070098" },
];
